import React, { useState, useEffect } from 'react';

import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import Card from 'components/Card/Card';
import CardBody from 'components/Card/CardBody';
import ReactTable from 'components/ReactTable/ReactTable.js';
import Button from 'components/CustomButtons/Button.js';
import { Toasty, useToasty } from 'hooks/Toasty';
import Checkbox from '@material-ui/core/Checkbox';

import { WithApp } from 'contexts/appContext';
import ModalFull from 'components/Tvendo/Common/ModalFull';
import { wsRemove } from 'services/WService';
import { FormControlLabel } from '@mui/material';

const columns = [
  { Header: '#', accessor: 'num', width: 90 },
  { Header: 'Código', accessor: 'ItemCode', width: 120 },
  { Header: 'Nombre producto', accessor: 'ItemName' },
  { Header: 'Marca', accessor: 'mark', width: 180 },
  { Header: 'Línea', accessor: 'line', width: 180 },
  { Header: 'Familia', accessor: 'family', width: 200 },
  { Header: 'Stock', accessor: 'OnHand', width: 100 },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

// Lista las filas del detalle del registro: las que se marcan se eliminan
export default WithApp(function ModalFilterProduct(props) {
  const { open, setOpen, details, getTransfer, dataChanging } = props;

  const [notify, showNotify] = useToasty();
  const [rows, setRows] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [deleting, setDeleting] = useState(false);

  useEffect(() => {
    setSelectedIds([]);
    if (!open) return;

    // El detalle viene agrupado: almacén > marca > línea > familia > productos
    let list = [];
    for (const warehouse of details || []) {
      for (const mark of warehouse.marks || []) {
        for (const line of mark.lines || []) {
          for (const family of line.families || []) {
            for (const detail of family.details || []) {
              list.push({
                ...detail,
                mark: mark.description,
                line: line.description,
                family: family.description,
              });
            }
          }
        }
      }
    }
    setRows(list);
  }, [open, details]);

  function handleSelect(id) {
    if (selectedIds.includes(id)) {
      setSelectedIds(selectedIds.filter((selectedId) => selectedId !== id));
    } else {
      setSelectedIds([...selectedIds, id]);
    }
  }

  async function deleteDetails() {
    if (selectedIds.length === 0) {
      showNotify('Marque los productos que quiere eliminar del detalle', 'error');
      return;
    }
    if (!window.confirm(`¿Eliminar ${selectedIds.length} producto(s) del detalle?`)) return;

    setDeleting(true);
    // La ruta pide un id de detalle, pero el backend elimina todos los que van en ids
    const response = await wsRemove(`logi/inventory/${dataChanging.id}/detail/${selectedIds[0]}`, {
      ids: selectedIds,
    });
    setDeleting(false);

    if (response.success) {
      showNotify(response.message);
      setOpen(false);
      getTransfer(dataChanging.id);
    } else {
      showNotify(response.message, 'error');
    }
  }

  return (
    <ModalFull title="Productos del detalle" open={open} setOpen={() => setOpen(false)}>
      <Toasty action={notify} />
      <Card>
        <CardBody>
          <GridContainer>
            <GridItem xs={12}>
              <Button
                color={props.themeContext.buttonColorDanger}
                style={{ marginTop: '15px', float: 'left' }}
                onClick={deleteDetails}
                disabled={deleting || selectedIds.length === 0}
              >
                Eliminar {selectedIds.length} producto(s) del detalle
              </Button>
            </GridItem>
            <GridItem xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={rows.length > 0 && selectedIds.length === rows.length}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setSelectedIds(rows.map((row) => row.id));
                      } else {
                        setSelectedIds([]);
                      }
                    }}
                  />
                }
                label="Marcar todos"
              />
              <p style={{ color: '#999', fontSize: '12px' }}>
                {rows.length} productos en el detalle, {rows.filter((row) => row.OnHand > 0).length} con stock.
              </p>
            </GridItem>
          </GridContainer>
          <ReactTable
            defaultWidth={1100}
            exportExcel={false}
            columns={columns}
            data={rows.map((row, i) => ({
              num: (
                <div className="actions-right">
                  {i + 1}
                  <Checkbox
                    checked={selectedIds.includes(row.id)}
                    onChange={() => handleSelect(row.id)}
                  />
                </div>
              ),
              ItemCode: row.ItemCode,
              ItemName: row.ItemName,
              mark: row.mark,
              line: row.line,
              family: row.family,
              OnHand: row.OnHand,
              actions: '',
            }))}
          />
        </CardBody>
      </Card>
    </ModalFull>
  );
});
